<template>
  <div class="header">
    <div class="header-left"></div>
    <div class="header-right">
      <div class="date-info">
        <span>{{ currentDate }}</span>
      </div>
      <div class="notification">
        <i class="el-icon-bell"></i>
      </div>
      <!-- 用户信息 -->
      <div class="user-info">
        <div class="user-avatar">
          <span class="user-avatar-text">{{ userRoleText }}</span>
        </div>
        <div class="user-detail">
          <span class="user-name">{{ userName }}</span>
        </div>
      </div>
      <!-- 退出登录 -->
      <div class="logout-btn" @click="handleLogout" title="退出登录">
        <i class="el-icon-switch-button"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      userInfo: null
    }
  },
  computed: {
    /**
     * 用户名称
     */
    userName() {
      if (!this.userInfo) return '未登录'
      return this.userInfo.nickname || this.userInfo.name || '未登录'
    },
    /**
     * 用户角色文本（用于头像图标）
     * type: 1 = 管理员, 2 = 员工
     */
    userRoleText() {
      if (!this.userInfo) return '?'
      return this.userInfo.type === 1 ? '管' : '员'
    },
    currentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}/${month}/${day}`
    }
  },
  created() {
    // 加载用户信息
    this.loadUserInfo()
  },
  methods: {
    /**
     * 加载用户信息
     */
    loadUserInfo() {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        try {
          this.userInfo = JSON.parse(userInfoStr)
        } catch (e) {
          console.error('解析用户信息失败', e)
        }
      }
    },
    /**
     * 退出登录
     */
    handleLogout() {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 清除本地存储
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          // 清除保存的账号密码
          localStorage.removeItem('loginInfo')
          this.$message.success('退出成功')
          // 跳转到登录页
          this.$router.push('/login')
        })
        .catch(() => {
          // 用户取消
        })
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 200px;
  right: 0;
  z-index: 999;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 24px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.header-left {
  flex: 1;
}

/* 用户信息 */
.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background-color: #dcfce7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-avatar-text {
  font-size: 14px;
  font-weight: 600;
  color: #166534;
}

.user-detail {
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1;
  text-align: center;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

/* 退出登录按钮 */
.logout-btn {
  font-size: 20px;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.3s;
}

.logout-btn:hover {
  color: #ef4444;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.date-info {
  color: #6b7280;
  font-size: 14px;
}

.notification {
  position: relative;
  font-size: 18px;
  color: #6b7280;
  cursor: pointer;
}
</style>
